const COPIED_TOOLTIP_DURATION = 1500;

const initProductSharing = () => {
  const containers = document.querySelectorAll('[data-product-sharing]');
  if (!containers.length) return;

  containers.forEach((container) => {
    if (container.dataset.sharingInitialised === 'true') return;

    const shareUrl = container.dataset.shareUrl;
    const shareTitle = container.dataset.shareTitle;
    const shareText = container.dataset.shareText;

    const tiktokBtn = container.querySelector('[data-share-tiktok]');
    const copyBtn = container.querySelector('[data-share-copy]');
    const copyTooltip = container.querySelector('[data-share-copy-tooltip]');

    const copyToClipboard = async () => {
      try {
        await navigator.clipboard.writeText(shareUrl);
        return true;
      } catch {
        return false;
      }
    };

    const showCopiedTooltip = () => {
      if (!copyTooltip) return;
      copyTooltip.classList.remove('hidden');
      setTimeout(() => copyTooltip.classList.add('hidden'), COPIED_TOOLTIP_DURATION);
    };

    tiktokBtn?.addEventListener('click', async () => {
      if (!navigator.share) return;
      try {
        await navigator.share({ title: shareTitle, text: shareText, url: shareUrl });
      } catch {
        // User cancelled or share failed — no-op.
      }
    });

    copyBtn?.addEventListener('click', async () => {
      const copied = await copyToClipboard();
      if (copied) showCopiedTooltip();
    });

    container.dataset.sharingInitialised = 'true';
  });
};

export default initProductSharing;
